export default Object.freeze({
  LEFT: 'left',
  RIGHT: 'right',
});
